/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.slice.js";

/* 任意数据拷贝 */
var deepCopy = function deepCopy(data) {
  var target; // 不能使用let 因为无法先声明在赋值

  if (!(data instanceof Object)) {
    // 返回基本类型
    return data;
  } else if (data instanceof Array) {
    target = [];
  } else if (data instanceof Object) {
    target = {};
  } else if (data instanceof Function) {// target = eval(data)
  }

  for (var key in data) {
    target[key] = deepCopy(data[key]);
  }

  return target;
}; // 2018-1-1 00:00 转换为 Wed Jul 25 2018 14:11:22 GMT+0800 (中国标准时间)


var formatDate = function formatDate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var time = String(data).split(' ');
  var sdate = time[0].split('-');
  var date = '';

  if (sdate.length > 0) {
    date = new Date(sdate[0], sdate[1] - 1, sdate[2]);
  } else {
    date = new Date();
  }

  if (time[1]) {
    var _date;

    var stime = time[1].split(':');

    (_date = date).setHours.apply(_date, _toConsumableArray(stime));
  }

  return date;
};

var date = {
  // 一天的时间戳
  oneDay: 24 * 60 * 60 * 1000,
  // 2018-1-1 00:00 转换为 Wed Jul 25 2018 14:11:22 GMT+0800 (中国标准时间)
  formatDate: function formatDate(data) {
    var time = data.split(' ');
    var sdate = time[0].split('-');
    var date = new Date(sdate[0], sdate[1] - 1, sdate[2]);

    if (time[1]) {
      var stime = time[1].split(':');
      date.setHours.apply(date, _toConsumableArray(stime));
    }

    return date;
  },
  // 获取当前时刻起间隔count天日期 count：3未来三天、-3过去三天
  getIntervalDayStartAndEnd: function getIntervalDayStartAndEnd() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var nowDate = new Date();
    var start = nowDate.Format(format);
    var end = new Date(nowDate.setTime(nowDate.getTime() + this.oneDay * count)).Format(format);
    startStop.push(start);
    startStop.push(end);
    return count >= 0 ? startStop : startStop.reverse();
  },
  // 获取今天日期 monthCount：0今天、-1昨天、1明天
  getDayStartAndEnd: function getDayStartAndEnd() {
    var dayCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var start = new Date(new Date().setHours(0, 0, 0) + this.oneDay * dayCount).Format(format);
    var end = new Date(new Date().setHours(23, 59, 59) + this.oneDay * dayCount).Format(format);
    startStop.push(start);
    startStop.push(end);
    return dayCount >= 0 ? startStop : startStop.reverse();
  },
  // 获取本月日期 monthCount：0当前月、-1上一个月、1下一个月
  getMonthStartAndEnd: function getMonthStartAndEnd() {
    var monthCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var currentDate = new Date();
    var month = currentDate.getMonth() + monthCount;

    if (month < 0) {
      var n = parseInt(-month / 12);
      month += n * 12;
      currentDate.setFullYear(currentDate.getFullYear() - n);
    }

    currentDate = new Date(currentDate.setMonth(month)); // 获得当前月份 0-11

    var currentMonth = currentDate.getMonth(); // 获得当前年份4位年

    var currentYear = currentDate.getFullYear(); // 获得上一个月的第一天

    var currentMonthFirstDay = new Date(currentYear, currentMonth, 1).Format(format); // 获得上一月的最后一天

    var currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0).setHours(23, 59, 59);
    currentMonthLastDay = new Date(currentMonthLastDay).Format(format);
    startStop.push(currentMonthFirstDay);
    startStop.push(currentMonthLastDay);
    return startStop;
  },
  // 获取本月日期 weekCount：0当本周、-1上一周、1下一周
  getWeekStartAndEnd: function getWeekStartAndEnd() {
    var weekCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var now = new Date();
    var nowTime = now.getTime();
    var day = now.getDay(); // 本周的第几天

    var MondayTime = nowTime - (day - 1) * this.oneDay + weekCount * 7 * this.oneDay;
    var SundayTime = nowTime + (7 - day) * this.oneDay + weekCount * 7 * this.oneDay;
    var start = new Date(MondayTime).setHours(0, 0, 0);
    var end = new Date(SundayTime).setHours(23, 59, 59);
    start = new Date(start).Format(format);
    end = new Date(end).Format(format);
    startStop.push(start);
    startStop.push(end);
    return weekCount >= 0 ? startStop : startStop.reverse();
  }
};
/* eslint-disable */

var rotateBase64Img = function rotateBase64Img(src, edg, callback) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var imgW; //图片宽度

  var imgH; //图片高度

  var size; //canvas初始大小

  if (edg % 90 != 0) {
    console.error('旋转角度必须是90的倍数!');
    throw '旋转角度必须是90的倍数!';
  }

  edg < 0 && (edg = edg % 360 + 360);
  var quadrant = edg / 90 % 4; //旋转象限

  var cutCoor = {
    sx: 0,
    sy: 0,
    ex: 0,
    ey: 0
  }; //裁剪坐标

  var image = new Image();
  image.crossOrigin = 'anonymous';
  image.src = src;

  image.onload = function () {
    imgW = image.width;
    imgH = image.height;
    size = imgW > imgH ? imgW : imgH;
    canvas.width = size * 2;
    canvas.height = size * 2;

    switch (quadrant) {
      case 0:
        cutCoor.sx = size;
        cutCoor.sy = size;
        cutCoor.ex = size + imgW;
        cutCoor.ey = size + imgH;
        break;

      case 1:
        cutCoor.sx = size - imgH;
        cutCoor.sy = size;
        cutCoor.ex = size;
        cutCoor.ey = size + imgW;
        break;

      case 2:
        cutCoor.sx = size - imgW;
        cutCoor.sy = size - imgH;
        cutCoor.ex = size;
        cutCoor.ey = size;
        break;

      case 3:
        cutCoor.sx = size;
        cutCoor.sy = size - imgW;
        cutCoor.ex = size + imgH;
        cutCoor.ey = size + imgW;
        break;
    }

    ctx.translate(size, size);
    ctx.rotate(edg * Math.PI / 180);
    ctx.drawImage(image, 0, 0);
    var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);

    if (quadrant % 2 == 0) {
      canvas.width = imgW;
      canvas.height = imgH;
    } else {
      canvas.width = imgH;
      canvas.height = imgW;
    }

    ctx.putImageData(imgData, 0, 0);
    callback(canvas.toDataURL());
  };
};

var getDistance = function getDistance(lng1, lat1, lng2, lat2) {
  var isEmpty = function isEmpty(n) {
    return n === null || n === '' || n === 'null' || n === undefined;
  };

  if (isEmpty(lng1) || isEmpty(lat1) || isEmpty(lng2) || isEmpty(lat2)) {
    return -1;
  }

  var PI = Math.PI;
  var EARTH_RADIUS = 6378137.0;

  var getRad = function getRad(d) {
    return d * PI / 180.0;
  };

  var radLat1 = getRad(lat1);
  var radLat2 = getRad(lat2);
  var a = radLat1 - radLat2;
  var b = getRad(lng1) - getRad(lng2);
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000.0;
  s = Math.round(s);
  return s;
};

var getTimeWord = function getTimeWord(dateTimeStamp) {
  if (typeof dateTimeStamp === 'string') {
    dateTimeStamp = new Date(dateTimeStamp).getTime();
  }

  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var month = day * 30;
  var result = '';
  var now = new Date().getTime();
  var diffValue = now - dateTimeStamp;
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;

  if (monthC >= 1) {
    result = parseInt(monthC) + '个月前';
  } else if (weekC >= 1) {
    result = parseInt(weekC) + '周前';
  } else if (dayC >= 1) {
    result = parseInt(dayC) + '天前';
  } else if (hourC >= 1) {
    result = parseInt(hourC) + '个小时前';
  } else if (minC >= 1) {
    result = parseInt(minC) + '分钟前';
  } else result = '刚刚';

  return result;
};

function scrollTop(el) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments.length > 2 ? arguments[2] : undefined;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var endCallback = arguments.length > 4 ? arguments[4] : undefined;

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }

  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);

  function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }

    var d = start + step > end ? end : start + step;

    if (start > end) {
      d = start - step < end ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }

    window.requestAnimationFrame(function () {
      return scroll(d, end, step);
    });
  }

  scroll(from, to, step);
}

export function showName(item) {
  var value = item.slice(item.lastIndexOf('/') + 1);
  return /\d+-.+/.test(value) ? value.split('-')[1] : value;
}
export { scrollTop, deepCopy };
export default {
  deepCopy: deepCopy,
  formatDate: formatDate,
  date: date,
  rotateBase64Img: rotateBase64Img,
  getTimeWord: getTimeWord,
  getDistance: getDistance
};